import React, { Children } from 'react';

import Paragraph from '@marvelapp/marvel-ui/paragraph';
import List from '@marvelapp/marvel-ui/list';
import Spacing from '@marvelapp/marvel-ui/spacing';

/* eslint-disable react/prop-types */
const l = function l({ type }) {
  return function(props) {
    const elements = filterChildren(props.children, child => child !== '\n');
    return (
      <Spacing type="margin" position="topBottom" size="m">
        <Paragraph tag="div" size="l">
          <List type={type}>{elements}</List>
        </Paragraph>
      </Spacing>
    );
  };
};

export default l;

function filterChildren(children, predicate) {
  return Children.toArray(children).filter(predicate);
}



// WEBPACK FOOTER //
// ./src/components/markdown/l.js